import Vue from 'vue'
import Vuex from 'vuex'
import auth from './modules/auth'
import cabinets from './modules/cabinets'
import clients from './modules/clients'
import comptes from './modules/comptes'
import configuration from './modules/configuration'
import creationStatuts from './modules/creationStatuts'
import dossiers from './modules/dossiers'
import dossiersStatuts from './modules/dossiersStatuts'
import echangeClients from './modules/echangeClients'
import echangeQuestions from './modules/echangeQuestions'
import echangeSujets from './modules/echangeSujets'
import equipes from './modules/equipes'
import fichiers from './modules/fichiers'
import lieuxCollectes from './modules/lieuxCollectes'
import lieuxProductions from './modules/lieuxProductions'
import mailsTypes from './modules/mailsTypes'
import modificationObserver from './modules/modificationObserver'
import programmes from './modules/programmes'
import prospects from './modules/prospects'
import provenances from './modules/provenances'
import recherchesSauvegardees from './modules/recherchesSauvegardees'
import resultatStatuts from './modules/resultatStatuts'
import tvaStatuts from './modules/tvaStatuts'
import tvaTypes from './modules/tvaTypes'
import typeMissions from './modules/typeMissions'
import users from './modules/users'
import gedTypes from './modules/gedTypes'
import lots from './modules/lots'
import wazo from './modules/wazo'
import clientCall from './modules/clientCall'
import lotClientStatus from "./modules/lotClientStatus"

Vue.use(Vuex)

// Register the store
export default new Vuex.Store({
    modules: {
        auth,
        cabinets,
        clients,
        comptes,
        configuration,
        creationStatuts,
        dossiers,
        dossiersStatuts,
        echangeClients,
        echangeQuestions,
        echangeSujets,
        equipes,
        fichiers,
        lieuxCollectes,
        lieuxProductions,
        lotClientStatus,
        mailsTypes,
        modificationObserver,
        programmes,
        prospects,
        provenances,
        recherchesSauvegardees,
        resultatStatuts,
        tvaStatuts,
        tvaTypes,
        typeMissions,
        users,
        gedTypes,
        lots,
        wazo,
        clientCall,
    },

    state: {
        minified: localStorage.minified ? localStorage.minified : false,
    },

    mutations: {
        setMinified: (state, minified) => {
            localStorage.setItem('minified', minified)
            state.minified = minified
        }
    },

    getters: {
        days: () => [
            'Dimanche',
            'Lundi',
            'Mardi',
            'Mercredi',
            'Jeudi',
            'Vendredi',
            'Samedi',
        ],

        months: () => [
            'Janvier',
            'Février',
            'Mars',
            'Avril',
            'Mai',
            'Juin',
            'Juillet',
            'Aout',
            'Septembre',
            'Octobre',
            'Novembre',
            'Décembre',
        ],

        optionsTypeRecurrence : () => [
            { value: 0, label: 'Hebdomadaire' },
            { value: 1, label: 'Mensuelle' },
        ],
    },
})
